/** Paints enough card-shaped placeholders to cover the currently visible horizontal Home row. */
export function paintHomeTopicRowSkeletons(container: HTMLElement): void {
	paintHomeRowSkeletons(container, 'home-topic-skeleton', 230, 3);
}

/** Paints the mobile New rail with the same compact rows as Saved. */
export function paintHomeNewTopicSkeletons(container: HTMLElement): void {
	const doc = container.ownerDocument ?? (typeof document === 'undefined' ? null : document);
	if (!doc) return;
	const groups = Array.from({ length: 2 }, () => {
		const group = doc.createElement('div');
		group.className = 'home-new-library-group';
		for (let index = 0; index < 3; index += 1) {
			const skeleton = doc.createElement('div');
			skeleton.className = 'home-topic-skeleton home-new-skeleton';
			skeleton.setAttribute('aria-hidden', 'true');
			group.appendChild(skeleton);
		}
		return group;
	});
	container.replaceChildren(...groups);
}

/**
 * The member Recent row is already present in the first DOM. Keep those
 * placeholders intact while auth/data resolve; only an empty or populated
 * reused row needs a fresh responsive skeleton set.
 */
export function paintHomeRecentRowSkeletons(container: HTMLElement): void {
	const skeletonClassNames = container.id === 'favorites-list' ? ['home-recent-skeleton', 'home-saved-skeleton'] : ['home-recent-skeleton'];
	if (hasOnlyHomeRecentSkeletonGroups(container, skeletonClassNames)) return;
	paintHomeRecentSkeletonGroups(container, skeletonClassNames);
}

function paintHomeRecentSkeletonGroups(container: HTMLElement, skeletonClassNames: string[]): void {
	const doc = container.ownerDocument ?? (typeof document === 'undefined' ? null : document);
	if (!doc) return;
	const groups = Array.from({ length: 3 }, () => {
		const group = doc.createElement('div');
		group.className = 'home-library-group';
		for (let index = 0; index < 2; index += 1) {
			const skeleton = doc.createElement('div');
			skeleton.className = skeletonClassNames.join(' ');
			skeleton.setAttribute('aria-hidden', 'true');
			group.appendChild(skeleton);
		}
		return group;
	});
	container.replaceChildren(...groups);
}

function paintHomeRowSkeletons(container: HTMLElement, className: string, cardWidth: number, minimum: number): void {
	const doc = container.ownerDocument ?? (typeof document === 'undefined' ? null : document);
	if (!doc) return;
	const gap = 12;
	const visibleWidth = container.offsetWidth || 1200;
	const count = Math.max(minimum, Math.ceil(visibleWidth / (cardWidth + gap)) + 1);
	const skeletons = Array.from({ length: count }, () => {
		const skeleton = doc.createElement('div');
		skeleton.className = className;
		skeleton.setAttribute('aria-hidden', 'true');
		return skeleton;
	});
	container.replaceChildren(...skeletons);
}

function hasOnlyHomeRecentSkeletonGroups(container: HTMLElement, skeletonClassNames: string[]): boolean {
	const groups = Array.from(container.children);
	return groups.length > 0 && groups.every((group) =>
		group.classList.contains('home-library-group') &&
		group.children.length === 2 &&
		Array.from(group.children).every((child) => skeletonClassNames.every((className) => child.classList.contains(className))),
	);
}
